import _ from 'lodash'
import { createSelector } from 'reselect'
import { encodeOccurrenceFromEvent } from '../Event/helpers/encodeOccurrence'

export const kioskStatus = state => _.get(state, 'kiosk.status', 'inactive')
export const isKioskMode = state => kioskStatus(state) !== 'inactive'
export const lastError = state => _.get(state, 'kiosk.error')

export const getOpportunity = state => _.get(state, 'kiosk.opportunity')
export const getEncodedOccurrence = state => encodeOccurrenceFromEvent(_.get(state, 'kiosk.opportunity'))
export const opportunityName = state => _.get(state, 'kiosk.opportunity.name')

export const organizationName = state => _.get(state, 'kiosk.opportunity.organization.name')
export const getOrganizationId = state => _.get(state, 'kiosk.opportunity.organization.id')

export const getVolunteers = state => _.get(state, 'kiosk.volunteers', [])
export const getRosterError = state => _.get(state, 'kiosk.getVolunteers.error', null)
export const getVolunteeringRoles = state => _.get(state, 'kiosk.volunteeringRoles', [])
export const getTimesheetMode = state => _.get(state, 'kiosk.timesheetMode', 'check-in')

export const hasWaivers = state => _.get(state, 'kiosk.hasWaivers', false)

export const getSearchQuery = state => _.get(state, 'kiosk.search.query', '')
export const getSearchLoading = state => _.get(state, 'kiosk.search.loading', false)
export const getRawSearchResults = state => _.get(state, 'kiosk.search.results', [])

// Results from /volunteer_search are people the operator has typed in but who
// are not in the local roster yet. The server already excludes anyone with an
// open active_volunteer session for this opportunity, so they are guaranteed
// not to be currently checked-in - we surface that to the UI by synthesising
// the activeVolunteer-shaped fields (checkedInAt, forceCheckOutAt) as null
// so the existing UsersList renders them with no special-casing.
export const getSearchResults = createSelector(getRawSearchResults, results =>
  _.map(results, volunteer => ({
    ...volunteer,
    checkedInAt: null,
    forceCheckOutAt: null,
  })),
)

export const getTimesheetList = createSelector(getVolunteers, getTimesheetMode, (volunteers, mode) => {
  let test = mode === 'check-in' ? t => t == null : t => t != null
  return _.chain(volunteers)
    .filter(v => test(v.checkedInAt))
    .orderBy(['missingRequiredMemberships', 'user.givenName', 'user.familyName'])
    .value()
})
